// Keep this logic aligned with apps/api/shared/competition_short_name.py.
// The CMS uses the same derivation for draft defaults and override comparisons.
const GENDER_PREFIX: Record<string, string> = {
  men: "Men's",
  women: "Women's",
  mixed: 'Mixed',
}

const TYPE_LABEL: Record<string, string> = {
  singles: 'Singles',
  doubles: 'Doubles',
  mixed: 'Mixed',
  mixed_doubles: 'Doubles',
}

function normalize(value: string | null | undefined): string | null {
  if (!value) return null
  const normalized = value.trim().toLowerCase()
  return normalized || null
}

export function deriveCompetitionShortName(
  gender: string | null | undefined,
  competitionType: string | null | undefined
): string {
  const normalizedGender = normalize(gender)
  const normalizedType = normalize(competitionType)

  if (normalizedGender && normalizedType) {
    const genderPrefix = GENDER_PREFIX[normalizedGender]
    const typeLabel = TYPE_LABEL[normalizedType]
    if (genderPrefix && typeLabel) {
      return `${genderPrefix} ${typeLabel}`
    }
    return `${normalizedGender} ${normalizedType}`
  }

  return [gender, competitionType]
    .map(part => part?.trim())
    .filter((part): part is string => Boolean(part))
    .join(' ')
}
